import AuthService from "../../intranet/auth/auth_service";
import { gerarUrl } from "../../../utilities/utils/Pageable";

export default class ResponsibleService extends AuthService {
  constructor() {
    super("responsavel");
  }

  findAllResponsible(queryParams) {
    const params = gerarUrl(queryParams);
    return this.execute("GET", `?${params}`).then((res) => res.data);
  }

  findByStatus(status) {
    return this.execute("GET", "/status/" + status).then((res) => res.data);
  }
  changeStatus(id) {
    return this.execute("PUT", `/status/${id}`);
  }
}
